import script from "./PlanFeatureItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanFeatureItem.vue?vue&type=script&setup=true&lang=js"

import "./PlanFeatureItem.vue?vue&type=style&index=0&id=0cc06912&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cc06912"]])

export default __exports__